import axios from "axios";
// import { setAlert } from './alert';

import {
  GET_CONTENT,
  CREATE_COURSE,
  CONTENT_ERROR,
  COURSE_FAIL,
  CLEAR_CONTENT,
  GET_COURSES,
  GET_COURSE,
  GET_COURSE_VIDEO,
  ADD_COURSE_COMMENT,
  DELETE_COURSE_COMMENT,
} from "./types";

// Get courses
export const getCourses = () => async (dispatch) => {
  dispatch({ type: CLEAR_CONTENT });
  try {
    const res = await axios.get("/api/course");

    dispatch({
      type: GET_COURSES,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: COURSE_FAIL,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get course by ID for authenticated users
export const getCourseById = (channelid, id) => async (dispatch) => {
  dispatch({ type: CLEAR_CONTENT });

  try {
    const res = await axios.get(`/api/course/${channelid}/${id}`);

    dispatch({
      type: GET_COURSE,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: CONTENT_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get course by ID for non-authenticated users
export const getCourseByIdNoAuth = (channelid, id) => async (dispatch) => {
  dispatch({ type: CLEAR_CONTENT });

  try {
    const res = await axios.get(`/api/course/no_auth/${channelid}/${id}`);

    dispatch({
      type: GET_COURSE,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: CONTENT_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get course video
export const getCourseVideo = (id, channelid, _id) => async (dispatch) => {
  try {
    const res = await axios.post(`/api/course/${channelid}/${id}/${_id}`);

    dispatch({
      type: GET_COURSE_VIDEO,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: CONTENT_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get user's courses content
export const getContentById = (channelid) => async (dispatch) => {
  try {
    const res = await axios.get(`/api/course/${channelid}`);
    dispatch({ type: CLEAR_CONTENT });

    dispatch({
      type: GET_CONTENT,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: CONTENT_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Create new course
export const createCourse =
  (
    coursetitle,
    coursedescription,
    coursePoster,
    purchasermessage,
    sections,
    attachments,
    files
  ) =>
  async (dispatch) => {
    const formData = new FormData();
    formData.append("coursetitle", JSON.stringify(coursetitle));
    formData.append("coursedescription", JSON.stringify(coursedescription));
    formData.append("purchasermessage", JSON.stringify(purchasermessage));
    formData.append("sections", JSON.stringify(sections));
    formData.append("attachments", JSON.stringify(attachments));
    formData.append("courseposter", coursePoster);

    files.map((file) => {
      formData.append("files", file);
    });

    const config = {
      data: formData,
      header: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    };

    try {
      const res = await axios.post(`/create_course`, formData, config);

      dispatch({
        type: CREATE_COURSE,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: COURSE_FAIL,
        payload: { msg: err.response.statusText, status: err.response.status },
      });
    }
  };

// Add comment
export const addCourseComment = (course, text) => async (dispatch) => {
  const formData = new FormData();
  formData.append("course", JSON.stringify(course));
  formData.append("text", JSON.stringify(text));

  const config = {
    data: formData,
    header: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const res = await axios.post(`/api/course/comment`, formData, config);

    dispatch({
      type: ADD_COURSE_COMMENT,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: COURSE_FAIL,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Delete comment
export const deleteCourseComment = (course, id) => async (dispatch) => {
  const formData = new FormData();
  formData.append("course", JSON.stringify(course));
  formData.append("id", JSON.stringify(id));

  const config = {
    data: formData,
    header: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const res = await axios.post(
      `/api/course/comment/delete`,
      formData,
      config
    );

    dispatch({
      type: DELETE_COURSE_COMMENT,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: COURSE_FAIL,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};
